import { FC, ReactNode } from "react";
import Select, { FormatOptionLabelMeta } from "react-select";

import { IInputProps } from "../../../modules/form";
import { isEqual, ObjectUtils } from "../../../modules/utils";

interface IAsyncDataConfig {
  pathLabel: string;
  pathValue: string;
  response: any;
}

export interface AreaOption {
  cases: string[];
  return: {
    value: string;
    label: string;
    color: string;
    isDisabled?: boolean;
  };
}

interface IInputSelect extends IInputProps {
  className?: string;
  options?: any;
  isClearable?: boolean;
  asyncData?: IAsyncDataConfig;
  placeholder?: string;
  isMulti?: boolean;
  AreaOptions?: AreaOption[];
  onInputChange?: (inputValue: string) => void;
  formatOptionLabel?: (option: any, labelMeta: FormatOptionLabelMeta<any, boolean>) => ReactNode;
  noOptionsMessage?: (obj: any) => string | null;
  closeMenuOnSelect?: boolean; // Thêm prop để điều khiển việc đóng menu khi chọn
}

// interface GroupedOption {
//   label: string;
//   options?: AreaOption[];
// }

export const InputSelect: FC<IInputSelect> = (props) => {
  const { asyncData, className } = props;

  // const groupedOptions: GroupedOption[] = [
  //   {
  //     label: "1",
  //     options: AreaOptions,
  //   },
  //   {
  //     label: "2",
  //     options: AreaOptions,
  //   },
  //   {
  //     label: "3",
  //     options: AreaOptions,
  //   },
  //   {
  //     label: "4",
  //     options: AreaOptions,
  //   },
  //   {
  //     label: "5",
  //     options: AreaOptions,
  //   },
  //   {
  //     label: "6",
  //     options: AreaOptions,
  //   },
  // ];

  const generalProps = {
    className: ["InputSelect", className].filter(Boolean).join(" "),
    classNamePrefix: "InputSelect",
    isSearchable: true,
    placeholder: props.placeholder || "-- Select --",
    onChange: (data: any) => props.onChange(data),
    defaultValue: props.defaultValue,
    onBlur: () => props.onTouched(),
    isClearable: typeof props.isClearable === "boolean" ? props.isClearable : true,
    isDisabled: props.isDisabled,
    isMulti: props.isMulti || false,
    isLoading: props.isLoading,
    onInputChange: props.onInputChange,
    formatOptionLabel: props.formatOptionLabel,
    closeMenuOnSelect: props.closeMenuOnSelect !== undefined ? props.closeMenuOnSelect : true, // Mặc định đóng menu khi chọn
  };

  // const groupStyles = {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  // };

  // const groupBadgeStyles: CSSProperties = {
  //   backgroundColor: "#EBECF0",
  //   borderRadius: "2em",
  //   color: "#172B4D",
  //   display: "inline-block",
  //   fontSize: 12,
  //   fontWeight: "normal",
  //   lineHeight: "1",
  //   minWidth: 1,
  //   padding: "0.16666666666667em 0.5em",
  //   textAlign: "center",
  // };

  // const formatGroupLabel = (data: GroupedOption) => (
  //   <div style={groupStyles}>
  //     <span>{data.label}</span>
  //     <span style={groupBadgeStyles}>{data?.options?.length}</span>
  //   </div>
  // );

  if (asyncData) {
    const { pathLabel, pathValue, response } = asyncData;
    const errorMessage = ObjectUtils.getIn(response, "error.message");

    if (!response) return <input disabled defaultValue="Fetching options..." />;
    if (errorMessage) return <input disabled defaultValue={`Error: ${errorMessage}`} />;

    const options = ObjectUtils.getIn(response, "data", [], (arr) =>
      arr.map((item: any) => ({
        label: ObjectUtils.getIn(item, pathLabel),
        value: ObjectUtils.getIn(item, pathValue, ""),
      })),
    );

    return (
      <Select
        {...generalProps}
        options={options}
        value={props.isMulti ? props.value : props.value ? options.find((v: any) => isEqual(props.value, v.value)) : ""}
      />
    );
  }

  return (
    <Select
      {...generalProps}
      options={props.options}
      noOptionsMessage={(obj: any) => (props.noOptionsMessage ? props.noOptionsMessage(obj) : "")}
      value={
        props.isMulti ? props.value : props.value ? props.options.find((v: any) => isEqual(props.value, v.value)) : ""
      }
    />
  );
};
